import { RoleHost } from '../RoleHost';

export function DBWrapper() {
  return <RoleHost role="db" />;
}
